import { Suspense } from 'react';
import { useRoutes, useLocation } from 'react-router-dom';
import routes from './config';
import DesktopLayout from '../components/feature/DesktopLayout';
import PageLoadingFallback from '../components/feature/PageLoadingFallback';
import { isVendorAllowedPath, isVendorUser } from '../lib/vendorGuard';
import { isCourierAllowedPath, isCourierUser } from '../lib/courierGuard';

export function DesktopRoutes() {
  const location = useLocation();
  const role = typeof window !== 'undefined' ? localStorage.getItem('userType') : null;
  const isVendorSession = isVendorUser(role);
  const isCourierSession = isCourierUser(role);
  const isStandalone =
    isVendorSession ||
    isCourierSession ||
    location.pathname.startsWith('/admin') ||
    location.pathname.startsWith('/vendor') ||
    location.pathname.startsWith('/courier') ||
    location.pathname.startsWith('/story-studio') ||
    location.pathname === '/search';

  const desktopRouteElement = useRoutes([
    {
      element: <DesktopLayout />,
      children: routes.filter(
        (r) =>
          !r.path?.startsWith('/admin') &&
          !r.path?.startsWith('/vendor') &&
          !r.path?.startsWith('/courier') &&
          !r.path?.startsWith('/story-studio')
      ),
    },
  ]);

  if (isStandalone) {
    let standalonePath = location.pathname;
    if (isVendorSession && !isVendorAllowedPath(location.pathname)) {
      standalonePath = '/vendor';
    } else if (isCourierSession && !isCourierAllowedPath(location.pathname)) {
      standalonePath = '/courier';
    }
    const standaloneRoute = routes.find((r) => {
      const routePath = r.path?.replace('/*', '') || '';
      if (routePath === '/') return standalonePath === '/';
      return standalonePath.startsWith(routePath) && routePath !== '';
    });
    if (standaloneRoute) {
      return (
        <Suspense fallback={<PageLoadingFallback />}>
          {standaloneRoute.element}
        </Suspense>
      );
    }
  }

  return (
    <Suspense fallback={<PageLoadingFallback />}>
      {desktopRouteElement}
    </Suspense>
  );
}
